<template>
  <div class="container mx-auto h-full py-5">
    <el-dialog
      title="Generar listado de empleados"
      :visible.sync="showEmployeeConfiguration"
      width="900px"
    >
      <el-form
        label-position="top"
        :model="employeeConf"
        status-icon
        ref="employeeConf"
        @submit.native.prevent="
          generateReport(reportType, 'employeeConf', employeeConf)
        "
      >
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="Tipo de documento">
              <el-radio-group v-model="employeeConf.type" class="w-full">
                <el-radio label="excel">Archivo EXCEL</el-radio>
                <!-- <el-radio label="pdf" disabled>Documento PDF</el-radio> -->
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="Selecciona los campos a incluir">
              <div class="w-full">
                <el-checkbox
                  label="Código anterior"
                  v-model="employeeConf.fields.priorCode"
                  name="type"
                />
                <el-checkbox
                  label="Nuevo código"
                  v-model="employeeConf.fields.code"
                  name="type"
                />
                <el-checkbox
                  label="Nombre completo"
                  v-model="employeeConf.fields.fullName"
                  name="type"
                />
                <el-checkbox
                  label="Nombre 1"
                  v-model="employeeConf.fields.name1"
                  name="type"
                />
                <el-checkbox
                  label="Nombre 2"
                  v-model="employeeConf.fields.name2"
                  name="type"
                />
                <el-checkbox
                  label="Nombre 3"
                  v-model="employeeConf.fields.name3"
                  name="type"
                />
                <el-checkbox
                  label="Apellido 1"
                  v-model="employeeConf.fields.lastname1"
                  name="type"
                />
                <el-checkbox
                  label="Apellido 2"
                  v-model="employeeConf.fields.lastname2"
                  name="type"
                />
                <el-checkbox
                  label="Apellido 3"
                  v-model="employeeConf.fields.lastname3"
                  name="type"
                />
                <el-checkbox
                  label="Fecha de Nac."
                  v-model="employeeConf.fields.dob"
                  name="type"
                />
                <el-checkbox
                  label="Calcular Edad"
                  v-model="employeeConf.fields.calcAge"
                  name="type"
                />
                <el-checkbox
                  label="Sexo"
                  v-model="employeeConf.fields.sex"
                  name="type"
                />
                <el-checkbox
                  label="Estado civil"
                  v-model="employeeConf.fields.civilStatus"
                  name="type"
                />
                <el-checkbox
                  label="Dirección 1"
                  v-model="employeeConf.fields.address1"
                  name="type"
                />
                <el-checkbox
                  label="Dirección 2"
                  v-model="employeeConf.fields.address2"
                  name="type"
                />
                <el-checkbox
                  label="País"
                  v-model="employeeConf.fields.country"
                  name="type"
                />
                <el-checkbox
                  label="Departamento"
                  v-model="employeeConf.fields.state"
                  name="type"
                />
                <el-checkbox
                  label="Municipio"
                  v-model="employeeConf.fields.city"
                  name="type"
                />
                <el-checkbox
                  label="# de celular"
                  v-model="employeeConf.fields.cellphone"
                  name="type"
                />
                <el-checkbox
                  label="# de telefono"
                  v-model="employeeConf.fields.phone"
                  name="type"
                />
                <el-checkbox
                  label="Correo"
                  v-model="employeeConf.fields.email"
                  name="type"
                />
                <el-checkbox
                  label="Nombre contacto de emergencia"
                  v-model="employeeConf.fields.emergencyPerson"
                  name="type"
                />
                <el-checkbox
                  label="Número contacto de emergencia"
                  v-model="employeeConf.fields.emergencyPhone"
                  name="type"
                />
                <el-checkbox
                  label="Cargo"
                  v-model="employeeConf.fields.department"
                  name="type"
                />
                <el-checkbox
                  label="Unidad Organizativa"
                  v-model="employeeConf.fields.unidadOrganizativa"
                  name="type"
                />
                <el-checkbox
                  label="Jefe(s) Inmediato(s)"
                  v-model="employeeConf.fields.jefeInmediato"
                  name="type"
                />
                <el-checkbox
                  label="Nomina"
                  v-model="employeeConf.fields.nomina"
                  name="type"
                />
                <el-checkbox
                  label="Escolaridad Maxima"
                  v-model="employeeConf.fields.escolaridadMaxima"
                  name="type"
                />
                <el-checkbox
                  label="Salario"
                  v-model="employeeConf.fields.salarioActual"
                  name="type"
                />
                <el-checkbox
                  label="Inicio de contrato"
                  v-model="employeeConf.fields.inicioContrato"
                  name="type"
                />
                <el-checkbox
                  label="Cuenta bancaria"
                  v-model="employeeConf.fields.cuentaBancaria"
                  name="type"
                />
                <el-checkbox
                  label="Departamento (sistema anterior)"
                  v-model="employeeConf.fields.oldDepartment"
                  name="type"
                />
                <el-checkbox
                  label="Centro de costo (sistema anterior)"
                  v-model="employeeConf.fields.oldCostCenter"
                  name="type"
                />
                <el-checkbox
                  label="DOCUMENTOS"
                  v-model="employeeConf.fields.documents"
                  name="type"
                />
                <el-checkbox
                  label="Sucursal"
                  v-model="employeeConf.fields.branchOffice"
                  name="type"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button size="small" @click="showEmployeeConfiguration = false"
              >Cancelar</el-button
            >
            <el-button size="small" type="primary" native-type="submit"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <ul class="grid grid-cols-12 gap-4">
      <li
        v-for="report in reports"
        :key="report.id"
        :class="
          report.disabled
            ? 'border-gray-400  rounded-md p-4 col-span-4  text-gray-400'
            : 'border-orange-200 hover:border-blue-200 rounded-md p-4 col-span-4 cursor-pointer hover:shadow-lg text-orange-800 hover:text-blue-800'
        "
        class="flex flex-col space-y-2 border"
        @click="generate(report.action)"
      >
        <div class="flex flex-row justify-between">
          <span class="font-semibold text-sm">{{ report.name }}</span>
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-html="report.icon"
          />
        </div>
        <span class="text-gray-700">{{ report.description }}</span>
      </li>
    </ul>

    <el-dialog
      title="Reporte de cumpleañeros"
      :visible.sync="showBirthdayRange"
      width="50%"
      center
    >
      <span>Seleccione el rango de fecha que desea mostrar en el reporte:</span>
      <div class="flex flex-col mr-5">
        <el-select v-model="month" filterable placeholder="Select">
          <el-option
            v-for="item in months"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button
          class="my-5 m justify-center"
          type="primary"
          @click="reportingBirthday()"
          :loading="loading"
          >Ver reporte</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="Reporte Asistente Estadistico"
      :visible.sync="showEstadisticRange"
      width="50%"
      center
    >
      <span>Seleccione el rango de fecha que desea mostrar en el reporte:</span>
      <div class="flex flex-row gap-4 justify-center" style="margin:auto;">
        <div>
          <el-select v-model="month" filterable placeholder="Mes">
            <el-option
              v-for="item in months"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select class="mx-2" v-model="year" filterable placeholder="Año">
            <el-option
              v-for="item in years"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>

        <div></div>
        <div>
          <el-button
            class=""
            type="primary"
            @click="reportingStatistic()"
            :loading="loading"
            >Ver reporte</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="Constancia de empleados"
      :visible.sync="showCostanciaModal"
      width="900px"
    >
      <div class="float-right mt-3">
        <el-select
          v-model="actualEmployeeSelected"
          size="mini"
          filterable
          placeholder="Lista de Empleados"
        >
          <el-option
            v-for="item in employees"
            :key="item.id"
            :label="fullname(item)"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          type="primary"
          size="mini"
          @click="setCurrentEmployee()"
          :loading="loading"
          >Seleccionar empleado
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import { format, differenceInYears, getDay, setYear } from "date-fns";
import XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { getHeader, getFooter, formatMoney } from "../../../utils";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "GeneralData",
  data() {
    return {
      actualEmployeeSelected: "",
      showBirthdayRange: false,
      showEstadisticRange: false,
      showCostanciaModal: false,
      loading: false,
      showEmployeeConfiguration: false,
      employeeConf: {
        type: "excel",
        country: "",
        state: "",
        city: "",
        fields: {
          code: false,
          priorCode: false,
          fullName: false,
          name1: false,
          name2: false,
          name3: false,
          lastname1: false,
          lastname2: false,
          lastname3: false,
          dob: false,
          calcAge: false,
          sex: false,
          civilStatus: false,
          address1: false,
          address2: false,
          country: false,
          state: false,
          city: false,
          cellphone: false,
          phone: false,
          email: false,
          emergencyPerson: false,
          emergencyPhone: false,
          department: false,
          unidadOrganizativa: false,
          jefeInmediato: false,
          nomina: false,
          escolaridadMaxima: false,
          salarioActual: false,
          inicioContrato: false,
          cuentaBancaria: false,
          oldDepartment: false,
          oldCostCenter: false,
          branchOffice: false,
          documents: false,
        },
      },
      employees: [],
      dayName: [
        {
          value: 1,
          label: "Lunes",
        },
        {
          value: 2,
          label: "Martes",
        },
        {
          value: 3,
          label: "Miercoles",
        },
        {
          value: 4,
          label: "Jueves",
        },
        {
          value: 5,
          label: "Viernes",
        },
        {
          value: 6,
          label: "Sábado",
        },
        {
          value: 0,
          label: "Domingo",
        },
      ],
      months: [
        {
          value: 1,
          label: "Enero",
        },
        {
          value: 2,
          label: "Febrero",
        },
        {
          value: 3,
          label: "Marzo",
        },
        {
          value: 4,
          label: "Abril",
        },
        {
          value: 5,
          label: "Mayo",
        },
        {
          value: 6,
          label: "Junio",
        },
        {
          value: 7,
          label: "Julio",
        },
        {
          value: 8,
          label: "Agosto",
        },
        {
          value: 9,
          label: "Septiembre",
        },
        {
          value: 10,
          label: "Octubre",
        },
        {
          value: 11,
          label: "Noviembre",
        },
        {
          value: 12,
          label: "Diciembre",
        },
      ],
      month: "",
      year: new Date().getFullYear(),
      reports: [
        {
          id: "birth",
          name: "CUMPLEAÑEROS POR MES",
          action: "birth",
          description:
            "Reporte de empleados que cumplen años durante un mes seleccionado.",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
        /*{
          id: "csalary",
          name: "CONSTANCIA DE SALARIO",
          action: "csalary",
          description:
            "Reporte para generar constancias para nuestros empleados por rango de fecha.",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled:false,
        },*/
        {
          id: "list",
          name: "LISTADO GENERAL DE EMPLEADOS",
          action: "list",
          description:
            "Reporte de empleados que puede incluir diferentes campos de información.",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },

        {
          id: "apersonal",
          name: "ACCIONES DE PERSONAL ",
          action: "apersonal",
          description: "ACCIONES DE PERSONAL ",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },

        {
          id: "aestadistico",
          name: "ASISTENTE ESTADÍSTICO",
          action: "aestadistico",
          description: "ASISTENTE ESTADÍSTICO",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },

        {
          id: "gisr",
          name: "GENERADOR DE CARTAS DE ISR",
          action: "gisr",
          description: "GENERADOR DE CARTAS DE ISR",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          employees(where: { show: true } whereNot: { status: 1 }){
                id
                name1
                name2
                name3
                lastname1
                lastname2
                lastname3
                currentSalary
                code
                contractStartDate
                department{ name }
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;

        if (R.isNil(errors)) {
          next((vm) => {
            return vm.setData({
              employees: data.employees,
            });
          });
        } else {
          next(new Error(errors[0].message));
        }
      });

    //asignacion de mes vigente
    next((vm) => vm.setCurrentMonth());
  },
  methods: {
    generateReport(reportType, formName, formData) {
      switch (reportType) {
        case "list":
          this.generateEmployeReport(formName, formData);
          break;
      }
    },
    generateEmployeReport(formName, formData) {
      if (Object.values(formData.fields).filter((v) => v).length == 0) {
        this.$notify({
          title: "Error",
          message: "Debes seleccionar algún campo a mostrar primero.",
          type: "error",
        });
        return false;
      }

      this.$confirm(
        `¿Estás seguro que deseas generar este reporte?`,
        "Confirmación",
        {
          confirmButtonText: `Si, generar`,
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";

              let values = "";
              values += formData.fields.priorCode
                ? "CodigoAnterior: priorCode "
                : "";
              values += formData.fields.code ? "CodigoActual: code " : "";
              values += formData.fields.fullName
                ? "name1 name2 name3 lastname1 lastname2 lastname3 "
                : "";
              values += formData.fields.name1 ? "Nombre1: name1 " : "";
              values += formData.fields.name2 ? "Nombre2: name2 " : "";
              values += formData.fields.name3 ? "Nombre3: name3 " : "";
              values += formData.fields.lastname1
                ? "Apellido1: lastname1 "
                : "";
              values += formData.fields.lastname2
                ? "Apellido2: lastname2 "
                : "";
              values += formData.fields.lastname3
                ? "Apellido3: lastname3 "
                : "";
              values += formData.fields.dob ? "FechaNac: dob " : "";
              values += formData.fields.sex ? "Sexo: sex " : "";
              values += formData.fields.civilStatus
                ? "EstadoCivil: civilStatus { name } "
                : "";
              values += formData.fields.address1 ? "Direccion1: address1 " : "";
              values += formData.fields.address2 ? "Direccion2: address2 " : "";
              values += formData.fields.country
                ? "Pais: country { name } "
                : "";
              values += formData.fields.state
                ? "Departamento: state { name } "
                : "";
              values += formData.fields.city ? "Ciudad: city { name } " : "";
              values += formData.fields.cellphone
                ? "NumCelular: cellphone "
                : "";
              values += formData.fields.phone ? " NumTelefono: phone " : "";
              values += formData.fields.email ? "Correo: email " : "";
              values += formData.fields.emergencyPerson
                ? "NombreContactoDeEmergencia: emergencyPerson "
                : "";
              values += formData.fields.emergencyPhone
                ? "NumeroContactoDeEmergencia: emergencyPhone "
                : "";
              values += formData.fields.department
                ? "Cargo: department { name } "
                : "";
              values += formData.fields.unidadOrganizativa
                ? "UnidadOrganizativa: department { parentDepartment { name } } "
                : "";
              values += formData.fields.jefeInmediato
                ? "JefeInmediato: department { parentDepartment { employees { name1, name2, lastname1, lastname2 } } } "
                : "";
              values += formData.fields.nomina
                ? "Nomina: paysheetType { name } "
                : "";
              values += formData.fields.escolaridadMaxima
                ? "EscolaridadMaxima: studies { studyLevel { id } career { name } }"
                : "";
              values += formData.fields.salarioActual
                ? "SalarioActual: currentSalary "
                : "";
              values += formData.fields.inicioContrato
                ? "InicioContrato: contractStartDate "
                : "";
              values += formData.fields.cuentaBancaria
                ? "CuentaBancaria: bankAccount "
                : "";
              values += formData.fields.branchOffice
                ? "Sucursal: branchOffice { name } "
                : "";
              values += formData.fields.oldDepartment
                ? "DepartamentoSistemaAnterior: oldDepartment { name } "
                : "";
              values += formData.fields.oldCostCenter
                ? "CentroCostoSistemaAnterior: oldCostCenter { name } "
                : "";
              values += formData.fields.documents
                ? "Documentos: documents { number documentType { name } } "
                : "";
              axios
                .post("/", {
                  query: `{
                    employees (where: { show: true, status: 2, terminated: false }) { ${values} }
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  //console.log(data);
                  const employees = data.employees.map((e) => {
                    const response = { ...e };
                    if (e.EstadoCivil != null) {
                      response.EstadoCivil = e.EstadoCivil.name;
                    }
                    if (e.Sucursal != null) {
                      response.Sucursal = e.Sucursal.name;
                    }
                    if (e.Nomina != null) {
                      response.Nomina = e.Nomina.name;
                    }
                    if (e.DepartamentoSistemaAnterior != null) {
                      response.DepartamentoSistemaAnterior =
                        e.DepartamentoSistemaAnterior.name;
                    }
                    if (e.CentroCostoSistemaAnterior != null) {
                      response.CentroCostoSistemaAnterior =
                        e.CentroCostoSistemaAnterior.name;
                    }
                    if (e.Departamento != null) {
                      response.Departamento = e.Departamento.name;
                    }
                    if (e.Cargo != null) {
                      response.Cargo = e.Cargo.name;
                    }
                    if (formData.fields.fullName) {
                      response.NombreCompleto = [
                        e.lastname1,
                        e.lastname2,
                        e.lastname3,
                        e.name1,
                        e.name2,
                        e.name3,
                      ]
                        .filter((e) => e)
                        .map((e) => e.trim())
                        .join(" ");
                      delete response.name1;
                      delete response.name2;
                      delete response.name3;
                      delete response.lastname1;
                      delete response.lastname2;
                      delete response.lastname3;
                    }
                    if (e.UnidadOrganizativa != null) {
                      response.UnidadOrganizativa =
                        e.UnidadOrganizativa.parentDepartment.name;
                    }
                    if (e.JefeInmediato != null) {
                      response.JefeInmediato = e.JefeInmediato.parentDepartment.employees
                        .map((e) => Object.values(e))
                        .map((e) => e.join(" "))
                        .join(" / ");
                    }
                    if (e.Ciudad != null) {
                      response.Ciudad = e.Ciudad.name;
                    }
                    if (formData.fields.calcAge && formData.fields.dob) {
                      response.Edad = differenceInYears(
                        new Date(),
                        new Date(e.FechaNac)
                      );
                    }
                    if (formData.fields.dob) {
                      response.FechaNac = format(
                        new Date(e.FechaNac + "T00:00:00"),
                        "DD/MM/YYYY"
                      );
                    }

                    if (formData.fields.inicioContrato) {
                      response.InicioContrato = format(
                        e.InicioContrato,
                        "DD/MM/YYYY"
                      ); //format(  new Date(e.InicioContrato),"DD/MM/YYYY");
                    }
                    if (formData.fields.sex) {
                      response.Sexo = e.Sexo == 1 ? "Masculino" : "Femenino";
                    }
                    if (e.EscolaridadMaxima != null) {
                      if (e.EscolaridadMaxima.length > 1) {
                        response.EscolaridadMaxima = e.EscolaridadMaxima.filter(
                          (s) => s.studyLevel.id != 10
                        ).sort((a, b) => {
                          if (a.studyLevel.id < b.studyLevel.id) return 1;
                          if (a.studyLevel.id > b.studyLevel.id) return -1;
                          return 0;
                        })[0].career.name;
                      } else {
                        response.EscolaridadMaxima =
                          e.EscolaridadMaxima.length > 0
                            ? e.EscolaridadMaxima[0].career.name
                            : "";
                      }
                    }
                    if (formData.fields.documents) {
                      for (const document of e.Documentos) {
                        response[document.documentType.name] = document.number;
                      }
                    }
                    return response;
                  });
                  const filename = `listado-empleados-${format(
                    new Date(),
                    "YYYYMMDDHHmmss"
                  )}`;
                  const worksheet = XLSX.utils.json_to_sheet(employees);
                  const wb = XLSX.utils.book_new(); // make Workbook of Excel
                  XLSX.utils.book_append_sheet(wb, worksheet, "Empleados");
                  XLSX.writeFile(wb, `${filename}.xlsx`); // name of the file is 'book.xlsx'
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = `Si, generar`;
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    setData({ employees }) {
      if (employees) {
        this.employees = employees;
      }
    },
    setCurrentMonth() {
      this.month = new Date().getMonth() + 1;
    },
    generate(action) {
      switch (action) {
        case "birth":
          this.showBirthdayRange = true;
          break;
        case "csalary":
          this.showCostanciaModal = true;
          break;
        case "list":
          this.showEmployeeConfiguration = true;
          this.reportType = action;
          break;
        case "aestadistico":
          this.showEstadisticRange = true;
          break;
      }
    },
    dateFormatJS(ndate) {
      let r = ndate.split("-");
      return new Date(r[1] + "/" + r[2] + "/" + r[0]);
    },
    fullname({
      code,
      name1,
      name2,
      name3,
      lastname1,
      lastname2,
      lastname3,
      department,
    }) {
      let name = [name1, name2, name3, lastname1, lastname2, lastname3]
        .filter((e) => e)
        .map((e) => e.trim())
        .join(" ");
      return (code ? code : " NC ") + " - " + name;
    },
    nameAndDayDate(d) {
      let splitDate = d.split("-");
      let newDate = setYear(this.dateFormatJS(d), new Date().getFullYear());
      let dayOfWeek = getDay(newDate);
      let dayDate = this.dayName.find((e) => e.value == dayOfWeek);
      //console.log(d+"--- "+newDate+" dayOfWeek "+dayOfWeek+": "+JSON.stringify(dayDate));
      return dayDate.label + " " + splitDate[2];
    },
    async reportingBirthday() {
      if (this.month == "") {
        this.$message.warning("Seleccione un mes");
        return;
      }

      let monthName = this.months.find((e) => e.value == this.month).label;

      await axios
        .post("/", {
          query: `{
  employees(
    where: { show: true, terminated:false } whereNot: { status: 1 }
    ){
        id
        code
        name1
        name2
        name3
        dob
        lastname1
        lastname2
        lastname3
        terminated
        oldDepartment{
          name
          }
        department{
            name
          }

  }
}`,
        })
        .then((res) => {
          //console.log(res.data.data.employees);
          const em = res.data.data.employees
            .filter((e) => {
              return e.dob.split("-")[1] == this.month;
            })
            .filter((e) => {
              return e.terminated == false;
            })
            .map((e) => ({ ...e, birthDay: e.dob.split("-")[2] }))
            .sort((a, b) => {
              if (a.birthDay > b.birthDay) return 1;
              if (a.birthDay < b.birthDay) return -1;
              return 0;
            })
            .map((e) => [
              { text: this.nameAndDayDate(e.dob) },
              { text: e.code },
              {
                text:
                  (e.name1 ? `${e.name1} ` : "") +
                  (e.name2 ? `${e.name2} ` : "") +
                  (e.name3 ? `${e.name3} ` : "") +
                  (e.lastname1 ? `${e.lastname1} ` : "") +
                  (e.lastname2 ? `${e.lastname2} ` : "") +
                  (e.lastname3 ? `${e.lastname3} ` : ""),
              },
              {
                text: "" + (e.oldDepartment ? e.oldDepartment.name : "-"),
              },
              { text: e.department.name },
            ]);

          // console.log(llll);

          // return false;
          // let em = res.data.data.employees
          //   .filter(
          //     (f) => format(new Date(f.dob + "T10:00:00Z"), "M") == this.month
          //   )
          //   .sort((a, b) => {
          //     //console.log(format(new Date(a.dob + "T10:00:00Z"), "D/MM"));
          //     var c = format(new Date(a.dob), "D");
          //     var d = format(new Date(b.dob), "D");
          //     return c + 1 - (d + 1);
          //   });
          // //console.log(em);

          // //console.log(this.nameAndDayDate("2021-04-24"));

          // let detailsEmp = [["DIA", "COD.", "NOMBRE", "DEPTO."]];
          // em.forEach((e) =>
          //   detailsEmp.push([
          //     { text: this.nameAndDayDate(e.dob), fontSize: 8 },
          //     { text: e.code, fontSize: 8 },
          //     {
          //       text:
          //         (e.name1 ? `${e.name1} ` : "") +
          //         (e.name2 ? `${e.name2} ` : "") +
          //         (e.name3 ? `${e.name3} ` : "") +
          //         (e.lastname1 ? `${e.lastname1} ` : "") +
          //         (e.lastname2 ? `${e.lastname2} ` : "") +
          //         (e.lastname3 ? `${e.lastname3} ` : ""),
          //     },
          //     {
          //       text: "" + (e.oldDepartment ? e.oldDepartment.name : "-"),
          //     },
          //   ])
          // );
          //console.log(em);

          let dd = {
            pageSize: "LETTER",
            pageOrientation: "portrait",
            pageMargins: [20, 60, 20, 40],
            header: getHeader(
              "CALDER, SOCIEDAD ANÓNIMA",
              " - MES DE " + monthName + "",
              "REPORTE DE CUMPLEAÑEROS",
              "custom"
            ),
            footer: getFooter(),
            content: [
              {
                style: "tableStyle",
                table: {
                  body: [["DIA", "COD.", "NOMBRE", "DEPTO.","PUESTO"], ...em],
                },
              },
            ],
            styles: {
              tableStyle: {
                fontSize: 8,
              },
            },
          };
          pdfMake.createPdf(dd).open();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message.error(err.message);
        });
    },
    async reportingStatistic() {
      if (this.month == "") {
        this.$message.warning("Seleccione un mes");
        return;
      }

      if (this.year == "") {
        this.$message.warning("Seleccione un año");
        return;
      }

      let monthName = this.months.find((e) => e.value == this.month).label;

      await axios
        .post("/", {
          query: `{
            ingresos: employees (where: { show: true } whereNot: { status: 1 }) {
              code
              sex
              dob
              name1
              name2
              name3
              lastname1
              lastname2
              lastname3
              contractStartDate
              currentSalary
              oldDepartment { name }
              oldCostCenter { name }
              cellphone
              phone
            }
            salidas: employeePersonalActions (where: { personalAction: "92" }) {
              startDate
              comment
              eventDate
              selectedOption
              employee {
                code
                sex
                dob
                name1
                name2
                name3
                lastname1
                lastname2
                lastname3
                contractStartDate
                currentSalary
                oldDepartment { name }
                oldCostCenter { name }
                cellphone
                phone
              }
            }
          }`,
        })
        .then(
          ({
            data: {
              data: { ingresos, salidas },
            },
          }) => {
            const inicial = ingresos.filter((e) => {
              return e.contractStartDate.split("-")[0] == this.year;
            });
            //console.log(inicial);
            const bajas = salidas
              .map((p) => ({
                ...p.employee,
                contractEndDate: p.eventDate,
                comment: p.comment,
              }))
              .filter((e) => e.contractEndDate != null)
              .filter((e) => e.contractEndDate.split("-")[0] == this.year);
            //console.log(bajas);

            const completePA = inicial.concat(bajas);
            //console.log(completePA);

            const applicableDepartments = [
              ...new Set(
                completePA.map((pa) =>
                  pa.oldDepartment ? pa.oldDepartment.name : null
                )
              ),
            ];

            if (completePA.length == 0) {
              return this.$message.warning(
                "No se encontraron registros para el año y mes seleccionado"
              );
            }

            const fillColor = "#99b8e6";
            const whiteColor = "#fff";
            const tableOverview = [
              {
                table: {
                  widths: [
                    "*",
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    20,
                    30,
                  ],
                  body: [
                    [
                      {
                        text: "RESUMEN",
                        bold: true,
                        colSpan: 14,
                        border: [false, false, false, true],
                      },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                      { text: "", border: [false, false, false, true] },
                    ],
                    [
                      { text: "CONCEPTO/MES", bold: true },
                      {
                        text: "ENE",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "01" ? fillColor : whiteColor,
                      },
                      {
                        text: "FEB",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "02" ? fillColor : whiteColor,
                      },
                      {
                        text: "MAR",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "03" ? fillColor : whiteColor,
                      },
                      {
                        text: "ABR",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "04" ? fillColor : whiteColor,
                      },
                      {
                        text: "MAY",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "05" ? fillColor : whiteColor,
                      },
                      {
                        text: "JUN",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "06" ? fillColor : whiteColor,
                      },
                      {
                        text: "JUL",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "07" ? fillColor : whiteColor,
                      },
                      {
                        text: "AGO",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "08" ? fillColor : whiteColor,
                      },
                      {
                        text: "SEP",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "09" ? fillColor : whiteColor,
                      },
                      {
                        text: "OCT",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "10" ? fillColor : whiteColor,
                      },
                      {
                        text: "NOV",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "11" ? fillColor : whiteColor,
                      },
                      {
                        text: "DIC",
                        bold: true,
                        alignment: "center",
                        fillColor: this.month == "12" ? fillColor : whiteColor,
                      },
                      { text: "TOTAL", bold: true, alignment: "center" },
                    ],
                    [
                      "NUEVAS CONTRATACIONES",
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "01"
                        ).length,
                        fillColor: this.month == "01" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "02"
                        ).length,
                        fillColor: this.month == "02" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "03"
                        ).length,
                        fillColor: this.month == "03" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "04"
                        ).length,
                        fillColor: this.month == "04" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "05"
                        ).length,
                        fillColor: this.month == "05" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "06"
                        ).length,
                        fillColor: this.month == "06" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "07"
                        ).length,
                        fillColor: this.month == "07" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "08"
                        ).length,
                        fillColor: this.month == "08" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "09"
                        ).length,
                        fillColor: this.month == "09" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "10"
                        ).length,
                        fillColor: this.month == "10" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "11"
                        ).length,
                        fillColor: this.month == "11" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: inicial.filter(
                          (pa) => pa.contractStartDate.split("-")[1] == "12"
                        ).length,
                        fillColor: this.month == "12" ? fillColor : whiteColor,
                      },
                      { alignment: "center", text: inicial.length },
                    ],
                    [
                      "DESPIDOS/RENUNCIAS",
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "01"
                        ).length,
                        fillColor: this.month == "01" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "02"
                        ).length,
                        fillColor: this.month == "02" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "03"
                        ).length,
                        fillColor: this.month == "03" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "04"
                        ).length,
                        fillColor: this.month == "04" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "05"
                        ).length,
                        fillColor: this.month == "05" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "06"
                        ).length,
                        fillColor: this.month == "06" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "07"
                        ).length,
                        fillColor: this.month == "07" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "08"
                        ).length,
                        fillColor: this.month == "08" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "09"
                        ).length,
                        fillColor: this.month == "09" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "10"
                        ).length,
                        fillColor: this.month == "10" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "11"
                        ).length,
                        fillColor: this.month == "11" ? fillColor : whiteColor,
                      },
                      {
                        alignment: "center",
                        text: bajas.filter(
                          (pa) => pa.contractEndDate.split("-")[1] == "12"
                        ).length,
                        fillColor: this.month == "12" ? fillColor : whiteColor,
                      },
                      { alignment: "center", text: bajas.length },
                    ],
                  ],
                },
              },
            ];

            const departments = [];
            for (const d of applicableDepartments) {
              let dinicial = [];
              let dbajas = [];
              if (!d) {
                dinicial = inicial.filter(
                  (i) =>
                    i.oldDepartment == null &&
                    i.contractStartDate.split("-")[1] == this.month
                );
              } else {
                dinicial = inicial.filter(
                  (i) =>
                    i.oldDepartment &&
                    i.oldDepartment.name.trim() == d &&
                    i.contractStartDate.split("-")[1] == this.month
                );
              }
              if (!d) {
                dbajas = bajas.filter(
                  (i) =>
                    i.oldDepartment == null &&
                    i.contractEndDate.split("-")[1] == this.month
                );
              } else {
                dbajas = bajas.filter(
                  (i) =>
                    i.oldDepartment &&
                    i.oldDepartment.name.trim() == d &&
                    i.contractEndDate.split("-")[1] == this.month
                );
              }

              if (dinicial.length > 0 || dbajas.length > 0) {
                departments.push([
                  {
                    table: {
                      widths: [
                        "*",
                        20,
                        20,
                        20,
                        20,
                        20,
                        20,
                        20,
                        20,
                        20,
                        20,
                        20,
                        20,
                        30,
                      ],
                      body: [
                        [
                          {
                            text: d ? d : "SIN DEPARTAMENTO",
                            bold: true,
                            colSpan: 14,
                            border: [false, false, false, true],
                            // margin: [0, 20, 0, 0],
                          },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                          { text: "", border: [false, false, false, true] },
                        ],
                        [
                          { text: "CONCEPTO/MES", bold: true },
                          {
                            text: "ENE",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "01" ? fillColor : whiteColor,
                          },
                          {
                            text: "FEB",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "02" ? fillColor : whiteColor,
                          },
                          {
                            text: "MAR",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "03" ? fillColor : whiteColor,
                          },
                          {
                            text: "ABR",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "04" ? fillColor : whiteColor,
                          },
                          {
                            text: "MAY",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "05" ? fillColor : whiteColor,
                          },
                          {
                            text: "JUN",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "06" ? fillColor : whiteColor,
                          },
                          {
                            text: "JUL",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "07" ? fillColor : whiteColor,
                          },
                          {
                            text: "AGO",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "08" ? fillColor : whiteColor,
                          },
                          {
                            text: "SEP",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "09" ? fillColor : whiteColor,
                          },
                          {
                            text: "OCT",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "10" ? fillColor : whiteColor,
                          },
                          {
                            text: "NOV",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "11" ? fillColor : whiteColor,
                          },
                          {
                            text: "DIC",
                            bold: true,
                            alignment: "center",
                            fillColor:
                              this.month == "12" ? fillColor : whiteColor,
                          },
                          { text: "TOTAL", bold: true, alignment: "center" },
                        ],
                        [
                          {
                            text: "NUEVAS CONTRATACIONES",
                            border: [true, false, true, false],
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "01"
                            ).length,
                            fillColor:
                              this.month == "01" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "02"
                            ).length,
                            fillColor:
                              this.month == "02" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "03"
                            ).length,
                            fillColor:
                              this.month == "03" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "04"
                            ).length,
                            fillColor:
                              this.month == "04" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "05"
                            ).length,
                            fillColor:
                              this.month == "05" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "06"
                            ).length,
                            fillColor:
                              this.month == "06" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "07"
                            ).length,
                            fillColor:
                              this.month == "07" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "08"
                            ).length,
                            fillColor:
                              this.month == "08" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "09"
                            ).length,
                            fillColor:
                              this.month == "09" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "10"
                            ).length,
                            fillColor:
                              this.month == "10" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "11"
                            ).length,
                            fillColor:
                              this.month == "11" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.filter(
                              (pa) => pa.contractStartDate.split("-")[1] == "12"
                            ).length,
                            fillColor:
                              this.month == "12" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, false],
                            text: dinicial.length,
                          },
                        ],
                        [
                          {
                            text: "DESPIDOS/RENUNCIAS",
                            border: [true, false, true, true],
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "01"
                            ).length,
                            fillColor:
                              this.month == "01" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "02"
                            ).length,
                            fillColor:
                              this.month == "02" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "03"
                            ).length,
                            fillColor:
                              this.month == "03" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "04"
                            ).length,
                            fillColor:
                              this.month == "04" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "05"
                            ).length,
                            fillColor:
                              this.month == "05" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "06"
                            ).length,
                            fillColor:
                              this.month == "06" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "07"
                            ).length,
                            fillColor:
                              this.month == "07" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "08"
                            ).length,
                            fillColor:
                              this.month == "08" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "09"
                            ).length,
                            fillColor:
                              this.month == "09" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "10"
                            ).length,
                            fillColor:
                              this.month == "10" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "11"
                            ).length,
                            fillColor:
                              this.month == "11" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.filter(
                              (pa) => pa.contractEndDate.split("-")[1] == "12"
                            ).length,
                            fillColor:
                              this.month == "12" ? fillColor : whiteColor,
                          },
                          {
                            alignment: "center",
                            border: [true, false, true, true],
                            text: dbajas.length,
                          },
                        ],
                        [
                          {
                            border: [true, false, true, true],
                            colSpan: "14",
                            table: {
                              widths: ["*", 110, 47, 47, 35, 90, 140],
                              body: [
                                [
                                  {
                                    text: "EMPLEADO",
                                    bold: true,
                                    border: [false, false, false, true],
                                  },
                                  {
                                    text: "CARGO",
                                    bold: true,
                                    border: [false, false, false, true],
                                  },
                                  {
                                    text: "F. INGRESO",
                                    bold: true,
                                    border: [false, false, false, true],
                                  },
                                  {
                                    text: "F. SALIDA",
                                    bold: true,
                                    border: [false, false, false, true],
                                  },
                                  {
                                    text: "SALARIO",
                                    bold: true,
                                    border: [false, false, false, true],
                                    alignment: "right",
                                  },
                                  {
                                    text: "JEFE INMEDIATO",
                                    bold: true,
                                    border: [false, false, false, true],
                                  },
                                  {
                                    text: "CONCEPTO",
                                    bold: true,
                                    border: [false, false, false, true],
                                  },
                                ],
                                ...dinicial.map((b, i) => {
                                  const fullName = `${
                                    b.name1 ? b.name1 + " " : ""
                                  }${b.name2 ? b.name2 + " " : ""}${
                                    b.name3 ? b.name3 + " " : ""
                                  }${b.lastname1 ? b.lastname1 + " " : ""}${
                                    b.lastname2 ? b.lastname2 + " " : ""
                                  }${b.lastname3 ? b.lastname3 + " " : ""}`;

                                  const [y, m, d] = b.contractStartDate.split(
                                    "-"
                                  );
                                  const startDate = `${d}/${m}/${y}`;
                                  return [
                                    {
                                      text: `${b.code} ${fullName}`,
                                      border: [false, false, false, false],
                                    },
                                    {
                                      text: "",
                                      border: [false, false, false, false],
                                    },
                                    {
                                      text: startDate,
                                      border: [false, false, false, false],
                                    },
                                    {
                                      text: "",
                                      border: [false, false, false, false],
                                    },
                                    {
                                      text: formatMoney(b.currentSalary),
                                      border: [false, false, false, false],
                                      alignment: "right",
                                    },
                                    {
                                      text: "",
                                      border: [false, false, false],
                                    },
                                    {
                                      text: "NUEVA CONTRATACION",
                                      border: [false, false, false],
                                    },
                                  ];
                                }),
                                ...dbajas.map((b, i) => {
                                  const fullName = `${
                                    b.name1 ? b.name1 + " " : ""
                                  }${b.name2 ? b.name2 + " " : ""}${
                                    b.name3 ? b.name3 + " " : ""
                                  }${b.lastname1 ? b.lastname1 + " " : ""}${
                                    b.lastname2 ? b.lastname2 + " " : ""
                                  }${b.lastname3 ? b.lastname3 + " " : ""}`;

                                  const [
                                    sy,
                                    sm,
                                    sd,
                                  ] = b.contractStartDate.split("-");
                                  const [ey, em, ed] = b.contractEndDate.split(
                                    "-"
                                  );
                                  const startDate = `${sd}/${sm}/${sy}`;
                                  const endDate = `${ed}/${em}/${ey}`;
                                  return [
                                    {
                                      text: `${b.code} ${fullName}`,
                                      border: [false, i == 0, false, false],
                                    },
                                    {
                                      text: "",
                                      border: [false, i == 0, false, false],
                                    },
                                    {
                                      text: startDate,
                                      border: [false, i == 0, false, false],
                                    },
                                    {
                                      text: endDate,
                                      border: [false, i == 0, false, false],
                                    },
                                    {
                                      text: formatMoney(b.currentSalary),
                                      border: [false, i == 0, false, false],
                                      alignment: "right",
                                    },
                                    {
                                      text: "",
                                      border: [false, i == 0, false, false],
                                    },
                                    {
                                      text: b.comment.toUpperCase(),
                                      border: [false, i == 0, false, false],
                                    },
                                  ];
                                }),
                              ],
                            },
                          },
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                        ],
                      ],
                    },
                  },
                ]);
              }
            }

            let dd = {
              pageSize: "LETTER",
              pageOrientation: "landscape",
              pageMargins: [20, 70, 20, 40],
              header: getHeader(
                "CALDER, SOCIEDAD ANÓNIMA",
                null,
                `AÑO: ${this.year} MES: ${monthName.toUpperCase()}`,
                null,
                "INFORME ESTADISTICO, RECURSO HUMANO (COMPLETO)"
              ),
              footer: getFooter(),
              content: [
                {
                  style: "tableStyle",
                  layout: {
                    defaultBorder: false,
                  },
                  table: {
                    widths: ["*"],
                    body: [
                      tableOverview,
                      ...departments,
                      [
                        {
                          table: {
                            widths: [
                              "*",
                              35,
                              15,
                              15,
                              25,
                              25,
                              25,
                              25,
                              25,
                              25,
                              25,
                              25,
                              25,
                              25,
                              25,
                            ],
                            body: [
                              [
                                {
                                  margin: [0, 10, 0, 0],
                                  border: [false, false, false, false],
                                  bold: true,
                                  text:
                                    "PROMEDIO DE EDADES/AÑOS LABORADOS/PERSONAL CON DISCAPACIDAD",
                                  colSpan: 15,
                                },
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                              ],
                              [
                                {
                                  border: [false, false, false, false],
                                  colSpan: 2,
                                  text: "",
                                },
                                "",
                                {
                                  colSpan: 2,
                                  text: "SEXO",
                                  bold: true,
                                  alignment: "center",
                                },
                                "",
                                {
                                  colSpan: 5,
                                  text: "EDADES ENTRE",
                                  bold: true,
                                  alignment: "center",
                                },
                                "",
                                "",
                                "",
                                "",
                                {
                                  colSpan: 6,
                                  text: "PROMEDIO DE AÑOS LABORADOS",
                                  bold: true,
                                  alignment: "center",
                                },
                                "",
                                "",
                                "",
                                "",
                                "",
                              ],
                              [
                                { bold: true, text: "DEPARTAMENTO" },
                                {
                                  bold: true,
                                  text: "No. EMP",
                                  alignment: "center",
                                },
                                { bold: true, text: "M", alignment: "center" },
                                { bold: true, text: "F", alignment: "center" },
                                {
                                  bold: true,
                                  text: "18 - 25",
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: "26 - 30",
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: "31 - 40",
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: "41 - 50",
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: "50+",
                                  alignment: "center",
                                },
                                { bold: true, text: "<1", alignment: "center" },
                                {
                                  bold: true,
                                  text: "1 - 3",
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: "4 - 6",
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: "7 - 10",
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: "11 - 14",
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: "14 +",
                                  alignment: "center",
                                },
                              ],
                              [
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                              ],
                              [
                                { bold: true, text: "TOTAL" },
                                {
                                  bold: true,
                                  text: completePA.length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter((d) => d.sex == 1)
                                    .length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter((d) => d.sex == 0)
                                    .length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) =>
                                      this.getAge(d.dob) >= 18 &&
                                      this.getAge(d.dob) <= 25
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) =>
                                      this.getAge(d.dob) >= 26 &&
                                      this.getAge(d.dob) <= 30
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) =>
                                      this.getAge(d.dob) >= 31 &&
                                      this.getAge(d.dob) <= 40
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) =>
                                      this.getAge(d.dob) >= 41 &&
                                      this.getAge(d.dob) <= 50
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) => this.getAge(d.dob) >= 51
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) => this.getAge(d.contractStartDate) < 1
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) =>
                                      this.getAge(d.contractStartDate) >= 1 &&
                                      this.getAge(d.contractStartDate) <= 3
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) =>
                                      this.getAge(d.contractStartDate) >= 4 &&
                                      this.getAge(d.contractStartDate) <= 6
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) =>
                                      this.getAge(d.contractStartDate) >= 7 &&
                                      this.getAge(d.contractStartDate) <= 10
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) =>
                                      this.getAge(d.contractStartDate) >= 11 &&
                                      this.getAge(d.contractStartDate) <= 14
                                  ).length,
                                  alignment: "center",
                                },
                                {
                                  bold: true,
                                  text: completePA.filter(
                                    (d) => this.getAge(d.contractStartDate) > 14
                                  ).length,
                                  alignment: "center",
                                },
                              ],
                            ],
                          },
                        },
                      ],
                    ],
                  },
                },
              ],
              styles: {
                tableStyle: {
                  fontSize: 8,
                },
              },
            };
            pdfMake.createPdf(dd).open();
          }
        )
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message.error(err.message);
        });
    },

    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
  },
  computed: {
    years: function() {
      let max = new Date().getFullYear();
      let min = max - 5;
      let yearList = [];

      for (var i = max; i >= min; i--) {
        var opt = document.createElement("option");
        yearList.push(i);
      }

      return yearList;
    },
  },
};
</script>
